import { localStorageKeys } from "config/localStorageKeys";
import { setTriggerAlert, updateSettings } from "store/users/slice";
import { GameType } from "types/game";

export const basicPrepareRouteToGame = (
  type: GameType,
  res: any,
  dispatch,
  disableShuffleBlock?: boolean
) => {
  if (type === "def_lead" && res?.Results?.length === 0) {
    return dispatch(
      setTriggerAlert({
        show: true,
        title: "Course is empty"
      })
    );
  }
  let gameId = null;
  let arrResult: any[] = [];

  const resLevels = localStorage.getItem("levels");
  const audit: number[] = [];
  if (resLevels && resLevels.length < 3) {
    const valLevel = JSON.parse(resLevels);
    if (valLevel?.ease) {
      audit.push(10);
    }
    if (valLevel?.medium) {
      audit.push(20);
    }
    if (valLevel?.hard) {
      audit.push(30);
    }
  }

  if (!disableShuffleBlock) {
    localStorage.setItem(localStorageKeys.shuffleAction, "");
    dispatch(
      updateSettings({
        shuffle: false
      })
    );
  }

  let storageKey = "";

  switch (type) {
    case "deffense":
      storageKey = localStorageKeys.deffensePlayExercises;
      break;
    case "hand_play":
      storageKey = localStorageKeys.handPlayExercises;
      break;
    case "def_lead":
      storageKey = localStorageKeys.defLeadPlayExercises;
      break;
    case "tricks":
      storageKey = localStorageKeys.tricksPlayExercises;
      break;
    case "bidding":
      storageKey = localStorageKeys.biddingPlayExercises;
      break;
    case "bidding_interactive":
      storageKey = localStorageKeys.biddingInteractivePlayExercises;
      break;
  }

  localStorage.setItem(storageKey, "");

  // eslint-disable-next-line no-unsafe-optional-chaining
  const booferListExercises = [...res?.Results];

  if (type === "tricks") {
    let findItem = booferListExercises?.find((item: any) => {
      return audit.includes(Number(item?.Data?.ExLevel));
    });

    if (!audit?.length) {
      findItem = booferListExercises[0];
    }
    return {
      gameId,
      arrResult,
      findItem
    };
  }
  if (booferListExercises && booferListExercises?.length > 0 && audit.length > 0) {
    booferListExercises?.forEach((item: any) => {
      const findItem = audit.find((val_audit) => {
        if (type === "hand_play" || type === "deffense") {
          return val_audit === item?.Data?.ExLevel;
        } else if (type === "def_lead" || type === "bidding" || type === "bidding_interactive") {
          return val_audit === item.Data?.Level;
        }
      });
      if (findItem) {
        arrResult.push(item);
      }
    });
  } else {
    arrResult = [...booferListExercises];
  }

  if (type === "hand_play" || type === "deffense") {
    arrResult = arrResult.sort((val1, val2) => {
      return val1?.Data?.ExIndex - val2?.Data?.ExIndex;
    });
  }

  if (arrResult?.length > 0) {
    if (type === "hand_play" || type === "deffense") {
      gameId = arrResult[0]?.Data?.ExIndex;
    } else if (type === "def_lead") {
      gameId = arrResult[0]?.Data?.ExerciseId;
    }
  }
  return {
    gameId,
    arrResult
  };
};
